// extracted by mini-css-extract-plugin
export var redoItem = "_mx-1";
export var redoTrigger = "_mx-0";